import script from "./AdminSidePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSidePanel.vue?vue&type=script&setup=true&lang=js"

import "./AdminSidePanel.vue?vue&type=style&index=0&id=58a34be8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58a34be8"]])

export default __exports__